import React from 'react'
import ProtectionUninstall from '../protection-uninstall'

const ProtectionUninstallDe = () => {
    return <ProtectionUninstall languageCode="de" />
}

export default ProtectionUninstallDe
